import { ADD_PLAYERS_TO_ROSTER, CONFIRM_ROSTER_PLAYERS, EDIT_ROSTER_PLAYER, EDIT_ROSTER_PLAYERS, PUBLISH_ROSTER, REMOVE_ROSTER_PLAYER, ROSTERS_REQUESTED, SET_ROSTER_STATUS, TAKE_FACE_CHECK } from '../constants/actionTypes';

export const addPlayersToRoster = ( context, token, gameId, team, teamId, players, teamOfficials ) => {

    return {
        type:    ADD_PLAYERS_TO_ROSTER,
        payload: { context, token, gameId, team, teamId, players, teamOfficials }
    };

};

export const confirmRosterPlayers = ( context, token, gameId, players ) => {

    return {
        type:    CONFIRM_ROSTER_PLAYERS,
        payload: { context, token, gameId, players }
    };

};

export const editRosterPlayer = ( context, token, gameId, team, teamId, player ) => {

    return {
        type:    EDIT_ROSTER_PLAYER,
        payload: { context, token, gameId, team, teamId, player }
    };

};

export const editRosterPlayers = ( context, token, gameId, team, teamId, players ) => {

    return {
        type:    EDIT_ROSTER_PLAYERS,
        payload: { context, token, gameId, team, teamId, players }
    };

};

export const loadRosters = ( context, token, gameId ) => {

    return {
        type:    ROSTERS_REQUESTED,
        payload: { context, token, gameId }
    };

};

export const publishRoster = ( context, token, gameId, team, teamId, publish ) => {

    return {
        type:    PUBLISH_ROSTER,
        payload: { context, token, gameId, team, teamId, publish }
    };

};

export const removeRosterPlayer = ( context, token, gameId, team, playerId, isTeamOfficial ) => {

    return {
        type:    REMOVE_ROSTER_PLAYER,
        payload: { context, token, gameId, team, playerId, isTeamOfficial }
    };

};

export const setRosterStatus = ( context, token, gameId, command ) => {

    return {
        type:    SET_ROSTER_STATUS,
        payload: { context, token, gameId, command }
    };

};

export const takeFaceCheck = ( context, token, gameId, team, teamId ) => {

    return {
        type:    TAKE_FACE_CHECK,
        payload: { context, token, gameId, team, teamId }
    };

};